import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WarningModalContentComponent } from '../../lib/warning-modal/warning-modal.component';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { ReferencesService } from 'src/app/services/references/references.service';
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import {ConstantsService} from "../../services/constants/constants.service";
import { ExportRefereeSettingsModalComponent } from '../reference-report-content/components/export-referee-settings-modal/export-referee-settings-modal.component';
import { Location } from '@angular/common';

import { ReferenceSummaryService, Area, FeedbackType } from '../../services/reference-summary';
import { AiSettingsService, AiSettingsResponse } from '../../services/ai-settings/ai-settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reference-modal',
  templateUrl: './reference-modal.component.pug',
  styleUrls: ['./reference-modal.component.scss'],
  standalone: false
})
export class ReferenceModalComponent implements OnInit {
  @Input() check:any;
  check_state_map={
    'requested':{
      'label': $localize`Requested`,
      'class': 'requested',
    },
    'in_progress':{
      'label': $localize`In progress`,
      'class': 'in_progress',
    },
    'completed':{
      'label': $localize`Completed`,
      'class': 'complete',
    },
    'stopped':{
      'label': $localize`Stopped`,
      'class': 'expired',
    },
    'expired':{
      'label': $localize`Expired`,
      'class': 'expired',
    }
  }
  requested_formatted: any;
  check_state: any;
  toBeCreated = false;
  toBeLinked = false;
  profileNotEnough = false;
  allowedRole =false;
  deleteRequestWarningModal: BsModalRef = new BsModalRef();
  exportModal: BsModalRef = new BsModalRef();
  // showComponent: Boolean = true;
  public deleteorstopAction: EventEmitter<any> = new EventEmitter();
  choices = new Array<{ key: string; value: string; disabled?: boolean; tooltip?: string; tooltipPosition?: string; tooltipCentred?: boolean }>();
  candidateReminderSent = false;
  candidateReminderSending = false;
  readonly RESEND_LINKS_FEATURE_FLAG = 'ent-12120-enable-clients-to-resend-links-in-the-platform';

  // Reference Summary properties
  referenceSummary: string = '';
  areasOfStrength: Area[] = [];
  areasOfImprovement: Area[] = [];
  areasOfNote: Area[] = [];
  feedback: FeedbackType = FeedbackType.Neutral;
  refereeCount: number = 1;
  currentUserUid: string = '';
  referenceSummaryId: number | null = null;
  aiSummaryEnabled = false;
  private aiSettingsSubscription?: Subscription;

  constructor(private router: Router,
              private referencesService: ReferencesService,
              private alertList: AlertBannerService,
              private bsModalRef: BsModalRef,
              public modalService: BsModalService,
              private permissionService: PermissionsService,
              private location: Location,
              private referenceSummaryService: ReferenceSummaryService,
              private aiSettingsService: AiSettingsService) {}

  ngOnInit(): void {
    this.browserBackButtonClickEvent();
    this.check.deleteperm = this.permissionService.hasUserPermissionCancel(this.check);
    if (
      (this.permissionService.hasPermission('can_view_reference_requests_list') &&
        this.permissionService.hasPermission('can_view_integrationuser_requests_list')) ||
      (this.permissionService.hasPermission('can_view_own_reference_requests_list')
        && this.check.user_questionnaire_permission && this.check.user_own_request) ||
      (this.permissionService.hasPermission('can_view_integrationuser_requests_list_restricted') &&
      !this.check?.is_restricted && this.check.user_own_request)
    ) {
      this.allowedRole = true;
    }


    this.referencesService.getLinkedPerson(this.check.id, this.check.candidate.email).subscribe(res=>{
      if(res && !res['check_uid']) this.toBeLinked = this.allowedRole && true;
    },
    error=>{
      if (error['error']['data']['errors']) this.toBeCreated = this.allowedRole && true;
    });
    this.requested_formatted = moment(this.check.requested).format('ll');
    if(this.check_state_map[this.check.xref.state]){
      this.check_state = this.check_state_map[this.check.xref.state];
    } else {
      this.check_state = this.check_state_map['in_progress'];
    }
    if (this.check?.xref.state=='requested' && this.check?.deleteperm) {
        this.choices.push({key: '1', value: $localize`Delete request`})
    }
    if (this.check?.xref.state=='in_progress' && this.check?.deleteperm)
    {
      this.choices.push({key: '2', value: $localize`Stop request`})
    }
    if (this.check?.xref.state!='requested' && this.check?.xref.state!='in_progress' || !this.check?.deleteperm) {
      this.choices.push({key: '3', value: $localize`No actions available`})
    }
    this.addSendReminderChoice();

    // Load AI settings and user profile details and reference summary
    this.aiSettingsSubscription = this.aiSettingsService.aiSettings$.subscribe({
      next: (settings: AiSettingsResponse | null) => {
        this.aiSummaryEnabled = settings?.config?.summary ?? false;
      },
      error: (error) => {
        console.error('Error loading AI settings for reference modal:', error);
        this.aiSummaryEnabled = false;
      }
    });

    // Initial load of AI settings
    this.aiSettingsService.getAiSettings().subscribe();

    this.currentUserUid = this.permissionService.data?.user?.uid || '';
    this.loadReferenceSummary();
  }

  browserBackButtonClickEvent() {
    this.location.subscribe((event) => {
      if (event.type === 'popstate') {
       this.permissionService.setNavCheck(true);
      }
    });
  }

  deleteorstopRequest(request) {
    let initialState = {
      'title': $localize`Delete request?`,
      'message': $localize`Are you sure you want to delete the request for ${request?.candidate.first_name} ${request?.candidate.last_name}`
    }
    if (request.xref.state == "in_progress") {
      initialState = {
        'title': $localize`Stop request?`,
        'message': $localize`Are you sure you want to stop the request for ${request?.candidate.first_name} ${request?.candidate.last_name}`
      }
    }
    this.deleteRequestWarningModal = this.modalService.show(WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal', initialState }
    );
    this.bsModalRef.hide();

    this.deleteRequestWarningModal.content.closeBtnName = 'Close';
    this.deleteRequestWarningModal.content.selection.subscribe(deleteBtnClicked => {
      if (deleteBtnClicked) {
        if (this.isThirdPartyIntegration(request)) {
          this.deleteThirdPartyRequest(request);
        } else {
          this.deleteOrStopEnterpriseRequest(request);
        }
      }
    });
  }

  isThirdPartyIntegration(request):boolean {
    return request.integration_sub !== ConstantsService.ENTERPRISE_PLATFORM_NAME;
  }

  private deleteOrStopEnterpriseRequest(request) {
    this.referencesService.deleteorstopCheck(request.id).subscribe(
      (res) => {
        if (res['data']['deleted']) {
          if (request.xref.state == "in_progress") {
            this.referencesService.getCheck(request.id).subscribe(
              res=>{
                this.alertList.append([{
                  type: AlertType.SUCCESS,
                  message: $localize`Success! The request has been stopped.`,
                  keepOnRouteChange: true,
                  modal: true
                }])
                const initialState={
                  'check': res
                }
                this.modalService.show(ReferenceModalComponent,{
                  class: 'modal-dialog-scrollable reference-modal', initialState
                })
                this.deleteorstopAction.emit({checkId: request.id});
              },
              error=>{
                console.log(error);
                this.alertList.append([{
                  type: AlertType.DANGER,
                  message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                  keepOnRouteChange: true
                }]);
              });
          }
          else if (request.xref.state == "requested"){
            this.deleteorstopAction.emit({checkId: request.id});
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The request has been deleted.`,
              keepOnRouteChange: true
            }])
          }
        }
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`This request has been started by the recipient and can no longer be deleted.`,
          keepOnRouteChange: true
        }]);
      })
  }

  private deleteThirdPartyRequest(request) {
    this.referencesService.deleteorstopCheck(request.id).subscribe(
      (res) => {
        this.referencesService.clearCache();
        this.deleteorstopAction.emit({checkId: request.id});
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! The request has been deleted.`,
          keepOnRouteChange: true
        }]);
      },
      error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Unable to delete this request. Please try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
  }

  refereeClicked(referee){
    if (referee.url){
      const refereeId = referee.url.split('/').pop();
      this.bsModalRef.hide();
      this.router.navigate([`reference-report/${this.check.id}/referee/${refereeId}`])
    }
  }
  onCancel(){
    this.bsModalRef.hide();
  }
  linkCheck(){
    this.referencesService.migratePerson(this.check.id, this.check.candidate.email, 'false').subscribe(res=>{
      this.toBeLinked = false;
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! The reference request has been linked to ${this.check.candidate.first_name} ${this.check.candidate.last_name}.`,
        keepOnRouteChange: true
      }]);
    },
    error=>{
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }
  createProfile(){
    this.referencesService.migratePerson(this.check.id, this.check.candidate.email, 'true').subscribe(res=>{
      this.toBeCreated = false;
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! A people record for ${this.check.candidate.first_name} ${this.check.candidate.last_name} has been created..`,
        keepOnRouteChange: true
      }]);
    },
    error=>{
      if( error.status == 400 ) {
        this.profileNotEnough = true;
        this.toBeCreated = false;
      } else {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    })
  }

  viewLifeCycle() {
    this.bsModalRef.hide();
    if (this.check.id) {
      localStorage.setItem('check_id', this.check.id)
    }
    this.permissionService.setNavCheck(false);
    this.router.navigateByUrl('/lifecycle', { state: { check: this.check } });
  }

  /**
   * Show Export report button if referee's are present
   * @returns Bool
   */
  showExportButton() {
    let refereeInAnsweredState = false;
    this.check.xref?.referees.forEach(referee => {
      if (referee.status.toLowerCase() === 'answered') refereeInAnsweredState = true
    })
    return refereeInAnsweredState;
  }

  /**
   * Show Export Settings Modal
   * When Export Settings Modal is closed open the current modal
   */
  showExportSettingsModal() {
      let initialState = {"refereeDetails": this.check.xref.referees, 'checkId': this.check.id};
      this.exportModal = this.modalService.show(ExportRefereeSettingsModalComponent, {
        class: 'modal-lg modal-dialog-centered max-width-900', initialState
      });
      this.bsModalRef.hide();
      this.exportModal.onHide?.subscribe(() => {
        const initialState={
          'check': this.check
        }
        this.modalService.show(ReferenceModalComponent,{
          class: 'modal-dialog-scrollable reference-modal', initialState
        })
      })
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  handleKebabAction(event, check) {
    switch (event.key)
    {
      case 'send_reminder':
        if (this.canSendCandidateReminder) {
          this.resendCandidateReminder(check);
        }
      break;
      case '1':
        this.deleteorstopRequest(check);
      break;
      case '2':
        this.deleteorstopRequest(check);
      break;
      case '3':
        this.stopEvent(event);
      break;
    }
  }

  get canSendCandidateReminder(): boolean {
    const state = this.check?.xref?.state;
    return this.permissionService.isFeatureActivated(this.RESEND_LINKS_FEATURE_FLAG) === true
      && (state === 'requested' || state === 'in_progress');
  }

  get candidateLastReminderTooltip(): string {
    if (!this.canSendCandidateReminder) {
      return '';
    }
    const lastReminderAt = this.check?.last_reminder_at;
    if (!lastReminderAt) {
      return '';
    }
    return $localize`Last reminder: ${moment(lastReminderAt).format('D MMM YYYY')}`;
  }

  addSendReminderChoice() {
    if (!this.canSendCandidateReminder) {
      return;
    }
    this.choices = this.choices.filter(choice => choice.key !== '3' && choice.key !== 'send_reminder');
    this.choices.unshift({
      key: 'send_reminder',
      value: $localize`Send reminder`,
      disabled: this.candidateReminderSent || this.candidateReminderSending,
      tooltip: this.candidateLastReminderTooltip,
      tooltipPosition: 'above',
      tooltipCentred: true
    });
  }

  setSendReminderDisabled(disabled: boolean) {
    const sendReminder = this.choices.find(choice => choice.key === 'send_reminder');
    if (sendReminder) {
      sendReminder.disabled = disabled;
    }
  }

  setSendReminderTooltip() {
    if (!this.canSendCandidateReminder) {
      return;
    }
    const sendReminder = this.choices.find(choice => choice.key === 'send_reminder');
    if (sendReminder) {
      sendReminder.tooltip = this.candidateLastReminderTooltip;
    }
  }

  resendCandidateReminder(check) {
    if (!this.canSendCandidateReminder || this.candidateReminderSent || this.candidateReminderSending) {
      return;
    }
    this.candidateReminderSending = true;
    this.setSendReminderDisabled(true);
    this.referencesService.resendCandidateEmail(check.id).subscribe(
      () => {
        this.candidateReminderSending = false;
        this.candidateReminderSent = true;
        this.check.last_reminder_at = moment().toISOString();
        this.setSendReminderDisabled(true);
        this.setSendReminderTooltip();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! The reminder has been sent.`,
          keepOnRouteChange: true
        }]);
      },
      () => {
        this.candidateReminderSending = false;
        this.setSendReminderDisabled(false);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
  }

  resendRefereeReminder(referee) {
    const blockedStatuses = ['answered', 'confirmed', 'declined', 'detached'];
    if (
      !this.canSendCandidateReminder ||
      blockedStatuses.indexOf(referee?.status) !== -1 ||
      referee?.reminderSent ||
      referee?.reminderSending
    ) {
      return;
    }
    referee.reminderSending = true;
    this.referencesService.resendRefereeEmail(this.check.id, referee.id).subscribe(
      () => {
        referee.reminderSending = false;
        referee.reminderSent = true;
        referee.last_reminder_at = moment().toISOString();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! The reminder has been sent.`,
          keepOnRouteChange: true
        }]);
      },
      () => {
        referee.reminderSending = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
  }

  // New methods for Reference Summary

  loadReferenceSummary() {
    if (this.check?.id && this.check?.candidate?.id && this.check?.xref?.referees?.length > 0) {
      const ua_identified = this.check.xref.referees.some(ref => ref?.unusual_activity === 'detected');
      const mas_identified = this.check.xref.referees.some(ref => ref?.unusual_activity === 'confirmed');

      // Extract reference summary from check data instead of making API call
      const transformedData = this.referenceSummaryService.extractReferenceSummaryFromCheck(this.check);

      if (transformedData) {
        this.referenceSummaryId = transformedData.id;
        this.referenceSummary = transformedData.summary;
        this.areasOfStrength = transformedData.areasOfStrength;
        this.areasOfImprovement = transformedData.areasOfImprovement;
        this.areasOfNote = transformedData.areasOfNote;
        this.feedback = transformedData.feedback;
        this.refereeCount = transformedData.refereeCount;

        // Append Areas of Note based on unusual activity flags
        if (ua_identified) {
          this.areasOfNote = [
            ...this.areasOfNote,
            {
              title: $localize`Unusual activity detected`,
              desc: $localize`There have been one or more unusual activity events detected.`
            } as Area
          ];
        }

        if (mas_identified) {
          this.areasOfNote = [
            ...this.areasOfNote,
            {
              title: $localize`Marked as suspicious`,
              desc: $localize`Unusual activity events have been detected and marked as suspicious by your team.`
            } as Area
          ];
        }
      } else {
        console.warn('Reference summary not found in check data');
      }
    }
  }

  onUserFeedback(feedback: FeedbackType) {
    this.feedback = feedback;

    // Call the service to save user feedback
    if (this.check?.id && this.currentUserUid && this.referenceSummaryId) {
      this.referenceSummaryService.setUserFeedback(
        this.check.id,
        this.referenceSummaryId,
        this.currentUserUid,
        feedback
      ).subscribe({
        next: (response) => {
          // User feedback saved successfully
        },
        error: (error) => {
          console.error('Error saving user feedback:', error);
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.aiSettingsSubscription) {
      this.aiSettingsSubscription.unsubscribe();
    }
  }
}
